import React from "react";
import TrackingPageFunctional from "./components/tracking-page-functional";

const TrackingPage = () => {
	return <TrackingPageFunctional />
};

export default TrackingPage;
